import React from "react";
import { formatNumber } from "../../../utils/number";
import { noData } from "../../../utils/string";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "./StatsItem";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { faHandHoldingUsd } from "@fortawesome/free-solid-svg-icons";
import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  timeline: {
    "& .MuiTimelineItem-missingOppositeContent": {
      "&::before": { content: "none" },
    },
  },
  item: { marginLeft: theme.spacing(1) },
  highlight: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "1.3em",
    marginBottom: theme.spacing(4),
  },
  finalItem: { marginBottom: theme.spacing(1) },
}));

export default function Stats({ plan, showFirst = true, showLast = true }) {
  const classes = useStyles();

  return (
    <div>
      <Timeline align="left" className={classes.timeline}>
        {showFirst && (
          <React.Fragment>
            <TimelineItem
              header="Revenue"
              text={
                <span>
                  Your Growth Plan will generate{" "}
                  <span className={classes.highlight}>
                    $
                    {plan?.projectedRevenue
                      ? formatNumber(Math.round(plan.projectedRevenue))
                      : noData()}
                    .
                  </span>
                </span>
              }
              icon={faMoneyBillAlt}
            />
            <TimelineItem
              header="Cost of Goods Sold (COGS)"
              text={
                <span>
                  To execute this Plan, you will need{" "}
                  <span className={classes.highlight}>
                    ${plan?.total ? formatNumber(plan.total) : noData()}.
                  </span>
                </span>
              }
              icon={faCog}
              includeConnector={showLast ? true : false}
              largeMarginBottom={showLast ? true : false}
            />
          </React.Fragment>
        )}
        {showLast && (
          <React.Fragment>
            <TimelineItem
              header="Growth Capital"
              text={
                <span>
                  8fig will provide{" "}
                  <span className={classes.highlight}>
                    {plan?.percentLoanCovered
                      ? formatNumber(plan.percentLoanCovered)
                      : noData()}
                    %
                  </span>{" "}
                  of the capital necessary.
                </span>
              }
              icon={faHandHoldingUsd}
            />
            <TimelineItem
              header="Cost of Capital"
              text={
                <span>
                  The cost to execute your Growth Plan using 8fig will be{" "}
                  <span className={classes.highlight}>
                    $
                    {plan?.costOfCapitalPerUnit
                      ? formatNumber(plan.costOfCapitalPerUnit)
                      : noData()}
                  </span>{" "}
                  per unit, or{" "}
                  <span className={classes.highlight}>
                    $
                    {plan.costOfCapital
                      ? formatNumber(plan?.costOfCapital)
                      : noData()}
                    .
                  </span>{" "}
                </span>
              }
              icon={faSearchDollar}
              includeConnector={false}
              largeMarginBottom={false}
            />
          </React.Fragment>
        )}
      </Timeline>
    </div>
  );
}
